import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import Pinned from '@shell/components/nav/Pinned.vue';
import { pinnableCluster } from '@shell/utils/cluster';

interface Props {
  cluster: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterRowPin',
  props: {
    cluster: {}
  },
  setup(__props: any) {

const props = __props;

const pinnable = computed(() => pinnableCluster(props.cluster));

return (_ctx: any,_cache: any) => {
  return (pinnable.value)
    ? (_openBlock(), _createBlock(Pinned, {
        key: 0,
        cluster: pinnable.value,
        class: "cluster-row-pin",
        "data-testid": "cluster-row-pin"
      }, null, 8, ["cluster"]))
    : _createCommentVNode("", true)
}
}

})